import React, {createContext, useState, useEffect, useContext, useRef} from "react";

export const ProcessContext = createContext();

export const ProcessProvider = ({
  children
}) => {

/*=====================================================
  Currency Configuration
=====================================================*/

const [currency, setCurrency] = useState("USD");

const currencies = {

    USD: {
        symbol: "$",
        rate: 1
    },

    NGN: {
        symbol: "₦",
        rate: 1650
    },

    GBP: {
        symbol: "£",
        rate: 0.74
    },

    EUR: {
        symbol: "€",
        rate: 0.86
    },

    CNY: {
        symbol: "¥",
        rate: 7.18
    },

    INR: {
        symbol: "₹",
        rate: 89.6
    },

    GHS: {
        symbol: "GH₵",
        rate: 12.8
    }

};

const exchangeRate =
    currencies[currency]?.rate || 1;

const currencySymbol =
    currencies[currency]?.symbol || "$";

const convertCurrency = (amount) => {

    const value = Number(amount) || 0;

    return value * exchangeRate;

};


  const defaultData = {

      /* FLOWS */
      FIC_1901: 0,

      /* PRESSURES */
      PT_1901: 0.03,

      /* TEMPERATURES */
      TT_1901: 25,
      TT_1902: 126,
      TT_1903: 38,
      TT_1904: 38,
      TT_1905: 126,
      TT_1906: 126,
      TT_1907: 126,
      TT_19010: 38,
      TT_19011: 0,
      TT_19012: 80,
      TT_19013: 45,

      TT_11003: 117,
      TT_11004: 110,
      TT_11006: 124,
      TT_11007: 130,

      TT_19015: 40,
        TT_19016: 30,

    TT_14005: 140,
    TT_14006: 95,

    TT_14007: 120,
    TT_14008: 95,

    TT_14009: 145,
    TT_14010: 120,

    TT_15005: 0,
    TT_15006: 0,
    TT_15007: 0,
    TT_15008: 0,

    TT_15009: 0,
    TT_15010: 0,

    TT_17003: 0,
    TT_17005: 0,

    TT_2004: 80,
    TT_2005: 120,

    TT_2006: 130,
    TT_2007: 210,

    FIC_16010: 0,
    FIC_16011: 0,
    FIC_16005: 0,

    PT_16005: 0.03,
    TT_16005: 25,

    FIC_18004: 0,
    FIC_18005: 0,
    FIC_18006: 0,

    FIC_18009: 0,
    FIC_18010: 0,

    TT_21013: 25,
    TT_21014: 25,

    spark: false,
    pilotOn: false,

    Damper_Opening: 75,
    ATM_Air: 25,

    A101A_Loovers: 100,
    A101B_Loovers: 100,
    A101C_Loovers: 100,
    A101D_Loovers: 80,
    ATM_Air: 25,

    FIC_1001: 0,
    PT_1001: 0.03,
    TT_1001: 25,

    CargoPumpRunning: false,
    CargoPumpTargetFlow: 0,

    inflowBBL: 0,
    FIQ_1001: 0,

    FIC_1308: 0,
    FIC_1309: 0,

    FIC_13010: 0,
    FIC_13011: 0,
    FIC_13012: 0,
    FIC_13013: 0,

    FIC_13017: 0,
    FIC_13018: 0,
    FIC_13019: 0,
    FIC_1502: 0,
    FIC_1503: 0,
    FIC_1407: 0,

    LOADING_START: "",
    LOADING_END: "",
    LOADING_DURATION: "",

    CUSTOMER_NAME: "",
    OPERATOR_NAME: "",
    VEHICLE_NUMBER: "",

    SELECTED_TRUCK: "",
    SELECTED_BARGE: "",
    LOADING_MODE: null,
    BATCH_STATUS: "READY",
    QUANTITY_BBL: 0,
    ACCUMULATOR_BBL: 0,
    PRODUCT_NAME: "",
    PRODUCT_API: "",
    PRODUCT_DENSITY: 0,
    PRODUCT_TEMPERATURE: 0,
    PRODUCT_BATCH_NO: "",
    LOADING_PERMIT: "",
    RECEIPT_NUMBER: "",
    COMPANY_NAME: "",
    DESTINATION: "",
    TRANSPORTER: "",


    };


    const [processData, setProcessData] =
  useState(() => {

    const saved =
      localStorage.getItem(
        "processData"
      );

    if (!saved) {
  return defaultData;
}

try {

  return JSON.parse(saved);

} catch {

  return defaultData;

}

});



useEffect(() => {

  const lastTime =
    Number(
      localStorage.getItem(
        "processData_time"
      )
    );

  if (!lastTime) return;

  const elapsedSeconds =
    (Date.now() - lastTime) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    let next = { ...prev };

    if (
      next.CargoPumpRunning &&
      next.CargoPumpTargetFlow > 0 &&
      next.inflowBBL > 0
    ) {

      const transferred =
            Number(next.FIC_1001 || 0) *
            elapsedSeconds;

      next.inflowBBL = Math.max(
        next.inflowBBL -
        transferred,
        0
      );

      next.FIQ_1001 =
        Number(next.FIQ_1001 || 0) +
        transferred;

      next.FIC_1001 =
        next.CargoPumpTargetFlow;

    }

    return next;

  });

}, []);


/* =========================================================
   CARGO PUMP GLOBAL SIMULATION
========================================================= */

const cargoIntervalRef = useRef(null);

useEffect(() => {

  if (cargoIntervalRef.current) return;

  cargoIntervalRef.current = setInterval(() => {

    setProcessData(prev => {

      const targetFlow =
        Number(prev.CargoPumpTargetFlow || 0);

      const running =
        prev.CargoPumpRunning;

      let FIC_1001 =
        Number(prev.FIC_1001 || 0);

      let inflowBBL =
        Number(prev.inflowBBL || 0);

      let FIQ_1001 =
        Number(prev.FIQ_1001 || 0);

      if (!running || targetFlow <= 0) {

        FIC_1001 =
          FIC_1001 +
          (0 - FIC_1001) * 0.12;

      } else {

        FIC_1001 =
          FIC_1001 +
          (
            targetFlow -
            FIC_1001
          ) * 0.12;

      }

      FIC_1001 =
        Number(FIC_1001.toFixed(2));

      if (
        running &&
        FIC_1001 > 0 &&
        inflowBBL > 0
      ) {

        const transferred =
          FIC_1001 * 0.5;

        inflowBBL =
          Math.max(
            inflowBBL -
            transferred,
            0
          );

        FIQ_1001 =
          FIQ_1001 +
          transferred;

      }

      return {
        ...prev,

        FIC_1001,

        inflowBBL:
          Number(
            inflowBBL.toFixed(2)
          ),

        FIQ_1001:
          Number(
            FIQ_1001.toFixed(2)
          )
      };

    });

  }, 500);

  return () => {

    clearInterval(
      cargoIntervalRef.current
    );

    cargoIntervalRef.current =
      null;

  };

}, []);



useEffect(() => {

  localStorage.setItem(
    "processData",
    JSON.stringify(processData)
  );

  localStorage.setItem(
    "processData_time",
    Date.now()
  );

}, [processData]);





  return (
    <ProcessContext.Provider
      value={{
        processData,
        setProcessData,
        currency,
        setCurrency,
        exchangeRate,
        currencySymbol,
        convertCurrency,

      }}
    >
      {children}
    </ProcessContext.Provider>
  );
};